import { connect } from 'react-redux'
import NumbersNewServiceModal from './NumbersNewServiceModal'
import showNumbersFormModal from 'features/Numbers/NumbersFormModal'
import { showMobileServiceFormModal } from 'features/MobileServices/MobileServiceFormModal'

const stateToProps = () => ({})

const dispatchToProps = {
  showNumbersFormModal,
  showMobileServiceFormModal,
}

export default connect(stateToProps, dispatchToProps)(NumbersNewServiceModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersNewServiceModal/NumbersNewServiceModal.container.js